import React from 'react';
import { Typography, Box, Container, Grid, Stack } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import { yellowGlowSx } from '../theme';
const reasons = [{
  icon: Diversity1OutlinedIcon,
  title: 'Proudly Woman-Owned',
  description: 'A woman-owned, locally rooted business built on personal service, trust, and a genuine eye for detail.'
}, {
  icon: VerifiedUserOutlinedIcon,
  title: 'Licensed & Insured',
  description: 'Fully licensed, bonded, and insured for your complete peace of mind on every project.'
}, {
  icon: DesignServicesOutlinedIcon,
  title: 'Custom Design',
  description: 'Every cover is designed to fit your space, style, and budget — never a one-size-fits-all kit.'
}, {
  icon: HandymanOutlinedIcon,
  title: 'Expert Installation',
  description: 'Experienced local crews build to last, with quality craftsmanship and attention to detail.'
}];
export function WhyChooseUs() {
  return <Box component="section" sx={{
    py: {
      xs: 8,
      md: 12
    },
    bgcolor: 'white'
  }} data-id="element-190">
      <Container maxWidth="lg" data-id="element-191">
        <Box sx={{
        textAlign: 'center',
        mb: 8,
        maxWidth: '720px',
        mx: 'auto'
      }} data-id="element-192">
          <Typography variant="h6" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} gutterBottom sx={yellowGlowSx} data-id="element-193">
            Why Homeowners Choose Us
          </Typography>
          <Typography variant="h2" color="primary.main" sx={{
          fontSize: {
            xs: '2.25rem',
            md: '3rem'
          }
        }} data-id="element-194">
            Quality You Can Relax Under
          </Typography>
        </Box>

        <Grid container spacing={4} data-id="element-195">
          {reasons.map(reason => {
          const Icon = reason.icon;
          return <Grid item xs={12} sm={6} md={3} key={reason.title} data-id="element-196">
                <Stack spacing={2} alignItems="center" sx={{
              textAlign: 'center',
              height: '100%'
            }} data-id="element-197">
                  <Box sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                bgcolor: 'rgba(255, 222, 89, 0.22)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} data-id="element-198">
                    <Icon color="secondary" sx={{
                  fontSize: 36
                }} data-id="element-199" />
                  </Box>
                  <Typography variant="h6" color="primary.main" fontWeight="bold" data-id="element-200">
                    {reason.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{
                lineHeight: 1.6
              }} data-id="element-201">
                    {reason.description}
                  </Typography>
                </Stack>
              </Grid>;
        })}
        </Grid>
      </Container>
    </Box>;
}